<template>
  <div class="v-retry m-retry-comp">
    <div :class="['v-retry-main', { failSmall: !isPage }]">
      <img
        :class="['v-retry-img', { imgSmall: !isPage }]"
        :src="imgUrl"
      />
      <p class="fail-text">
        {{ message }}
      </p>
    </div>
    <VButton
      :class="['retry-btn', { btnSmall: !isPage }]"
      @click="handleRetry"
    >
      {{ retryBtnText || 'Retry' }}
    </VButton>
  </div>
</template>

<script>
import VButton from 'fe-vui/button'
import { DEFAULT_ERROR_TEXT } from '@ms/config/message'
import defaultImg from 'wap/directive/block-loading/libs/img/error.png'

export default {
  name: 'Retry',
  components: {
    VButton
  },
  props: {
    loading: {
      type: [Boolean, Number],
      default: true
    },
    // 加载失败提示信息
    message: {
      type: String,
      default: DEFAULT_ERROR_TEXT
    },
    imgUrl: {
      type: String,
      default: defaultImg
    },
    // 重试按钮文案
    retryBtnText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    isPage: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleRetry() {
      this.$emit('retry')
    }
  }
}
</script>
<style lang="scss" scoped>
.m-retry-comp {
  width: calc(275 / 375 * 100%);
  padding: 50px 0;
  margin: 0 auto;
  color: #999;
  font-size: 12px;
  line-height: 16px;
  text-align: center;

  .v-retry-main {
    &.failSmall {
      display: flex;
      align-items: center;
      justify-content: center;

      .fail-text {
        margin-left: 20px;
        text-align: left;
      }
    }
  }

  .v-retry-img {
    width: 140px;
    margin-bottom: 10px;

    &.imgSmall {
      width: 80px;
      margin-bottom: 0;
    }
  }

  .retry-btn {
    width: 140px;
    height: 36px;
    border-radius: 18px;
    margin: 40px auto 0;
    background: #ffca27;
    font-size: 12px;
    line-height: 36px;

    &.btnSmall {
      margin: 20px auto 0;
    }
  }
}
</style>
